// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__VIqN4","wrapper":"style_wrapper__30qI-"};